// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Panel":"bcl_a bhf_ea bhf_kb bhf_js bhf_sl bhf_wj"};